/**
 * User-related utility functions
 */

/**
 * Convert user type to readable label
 * @param {string} userType - The user type from the database
 * @returns {string} - Human-readable user type label
 */
export const getUserTypeLabel = (userType) => {
  switch (userType) {
    case "super_admin":
      return "Super Admin";
    case "admin":
      return "Admin";
    case "user":
      return "User";
    default:
      return userType;
  }
};

/**
 * Get CSS classes for user type badges
 * @param {string} userType - The user type from the database
 * @returns {string} - Tailwind CSS classes for the badge
 */
export const getUserTypeBadgeClasses = (userType) => {
  switch (userType) {
    case "admin":
      return "bg-blue-100 text-blue-800";
    case "super_admin":
      return "bg-purple-100 text-purple-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

/**
 * Check if user is a super admin
 * @param {string} userType - The user type from the database
 * @returns {boolean} - True if user is super admin
 */
export const isSuperAdmin = (userType) => {
  return userType === "super_admin";
};

/**
 * Check if user is an admin (including super admin)
 * @param {string} userType - The user type from the database
 * @returns {boolean} - True if user is admin or super admin
 */
export const isAdmin = (userType) => {
  return userType === "admin" || userType === "super_admin";
};
